var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"total-data"},[_c('ul',_vm._l((_vm.data),function(item){return _c('li',{key:item.name},[_c('div',{staticClass:"total-data-title margin-bottom-10"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"total-data-num"},[_vm._v(" "+_vm._s(item.data)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }